import { Link, NavLink } from "react-router-dom";
import { getCategories, getTags } from "../../lib/taxonomy";
import { categoryPath, tagPath } from "../../lib/slug";

export function Sidebar() {
  const categories = getCategories();
  const tags = getTags().slice(0, 12);

  return (
    <aside className="sidebar" aria-label="Wiki navigation">
      <nav className="sidebar__section" aria-labelledby="sidebar-main">
        <h2 id="sidebar-main">Navigation</h2>
        <NavLink to="/">Main page</NavLink>
        <NavLink to="/search">Search</NavLink>
        <NavLink to="/about">About yawiki</NavLink>
      </nav>

      <section className="sidebar__section" aria-labelledby="sidebar-categories">
        <h2 id="sidebar-categories">Categories</h2>
        {categories.map((category) => (
          <Link key={category.slug} to={categoryPath(category.name)}>
            {category.name} <span>{category.count}</span>
          </Link>
        ))}
      </section>

      <section className="sidebar__section" aria-labelledby="sidebar-tags">
        <h2 id="sidebar-tags">Popular tags</h2>
        <div className="sidebar-tags">
          {tags.map((tag) => (
            <Link key={tag.slug} to={tagPath(tag.name)}>
              {tag.name}
            </Link>
          ))}
        </div>
      </section>
    </aside>
  );
}
